import { FolderKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderByIdRequest, GetFolderByIdResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useFolderByIdQuery(req: GetFolderByIdRequest, options?: SimpleQueryOptions<GetFolderByIdResponse, GetFolderByIdRequest>) {
  return useBaseQuery({
    queryKey: [FolderKey.FolderById, String(req.folderId)],
    fnOption: { url: FolderUrl.getFolderById(req.folderId), request: req },
    ...options,
  });
}
